import * as React from 'react';
import { Toolbar, ToolbarProps } from '@mui/material';
import { grey } from '@mui/material/colors';

export default function FToolbar(props: ToolbarProps) {
  const { children, ...rest } = props;

  return (
    <Toolbar
      sx={{
        display: 'flex', alignItems: 'center',
        justifyContent: 'center',
        // bgcolor: grey[100]
      }}
      {...rest}
    >
      {children}
    </Toolbar>
  );
}
